import { createContext } from "react";

export type ToastSeverity = "success" | "error" | "info" | "warning";

export interface ToastContextType {
  showToast: (message: string, severity?: ToastSeverity) => void;
  showSuccess: (message: string) => void;
  showError: (message: string, error?: unknown) => void;
  showInfo: (message: string) => void;
  showWarning: (message: string) => void;
}

export const ToastContext = createContext<Partial<ToastContextType>>({});
